import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ProgressBar } from "@animech/ui";
import * as Styled from "./loading-overlay.style";
export var LoadingOverlay = function () { return (_jsx(Styled.LoadingOverlay, { "data-testid": "loading-overlay-root", children: _jsx("div", { "data-testid": "loading-overlay-progress", className: "".concat(Styled.prefix, "-loading"), children: _jsx(ProgressBar, {}) }) })); };
